import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Box, Typography } from '@mui/material';
import { Loading, useInjectedComponent } from '@cnx-saas/common-fe';
import { AllocationWidgetType } from '@cnx-saas/common/generated';

export type ShipmentStatusCountProps = {
  status: AllocationWidgetType;
};

export function ShipmentStatusCount(props: ShipmentStatusCountProps) {
  const ShipmentStatusCountWidget = useInjectedComponent(
    'shipmentExecution/ShipmentStatusCountWidget',
  );

  return (
    <ErrorBoundary
      fallback={
        <Typography variant="h6" padding={2}>
          Error loading component
        </Typography>
      }
    >
      <Suspense fallback={<Loading />}>
        {ShipmentStatusCountWidget && (
          <Box>
            <ShipmentStatusCountWidget {...props} />
          </Box>
        )}
      </Suspense>
    </ErrorBoundary>
  );
}
